import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[woNoDataTitle]',
  standalone: true,
})
export class NoDataTitleDirective {
  public constructor(public readonly template: TemplateRef<unknown>) {}
}

@Directive({
  selector: '[woNoDataSubtitle]',
  standalone: true,
})
export class NoDataSubtitleDirective {
  public constructor(public readonly template: TemplateRef<unknown>) {}
}
